import { EntityId } from 'entities-next/common'
import { useDispatch } from 'react-redux'
import { setOneDeal } from 'scenes/Dashboard/data/deals/actions'
import { apiUpdateDealData } from 'scenes/Dashboard/data/deals/api'
import { Deal } from 'scenes/Dashboard/data/deals/types'

export function useDealHandlers(dealId: EntityId, onSuccess?: () => void) {
  const dispatch = useDispatch()
  const updateDealData = async (corporateDealData: Partial<Deal>) => {
    const updatedDeal = await apiUpdateDealData(dealId, corporateDealData)
    dispatch(setOneDeal(updatedDeal))
    if (onSuccess) {
      onSuccess()
    }
  }

  return {
    updateDealData,
  }
}
